import React, { useState } from 'react'
import { SearchIcon, EyeIcon } from '@heroicons/react/solid';
import { DocumentDownloadIcon, PlusCircleIcon } from "@heroicons/react/outline";
import Layout from './../../components/Layout/Layout';
import { useEffect } from 'react';
import { PencilIcon, CheckIcon } from '@heroicons/react/outline';
import AppModServices from '../../services/AppModServices';
import Paginate from '../../utils/Paginate';
import fire from './../../utils/Toastr';


export default function ApplicationModule() {
    const [primMail, setprimMail] = useState("");
    const [secMail, setSecMail] = useState("");
    const [appMod, setAppMod] = useState([]);
    const [search, setSearch] = useState("")
    const [pageIndex, setPageIndex] = useState(1);
    const [prevPage, setPrev] = useState(false);
    const [pageNumber, setPageNumber] = useState(1);
    const [totalPage, setPage] = useState(0)
    const [nextPage, setNextPage] = useState(false);
    const [pageLength, setPageLength] = useState("");
    const [primValue, setPrimValue] = useState("");
    const [secValue, setSecValue] = useState("")

    const listAppMod = async () => {
        const resp = await AppModServices.listMod(pageIndex, 10, search);
        setAppMod([...resp.data.result]);
        setPageLength([...resp.data.result].length);
        setPageNumber(resp.data.totalCount)
        setPageIndex(resp.data.pageIndex)
        setPrev(resp.data.hasPreviousPage);
        setNextPage(resp.data.hasNextPage);
        setPage(resp.data.totalPages);
    }
    const searchMod = async (text) => {
            setSearch(text);
    }

    const handlePriMail = async (e) => {
        setPrimValue(e);
    }
    const handleSecMail = async (e) => {
        setSecValue(e)
    }
    const edit = async (prim) => {
        setprimMail(prim)
    }
    const updatePrim = async (mod) => {
        if (primValue.length === 0) {
            const resp = await AppModServices.addPrimaryMailing({
                moduleId: mod.id,
                primaryMailingList: [mod.primaryMailingList],
                secondryMailingList: [secValue]
            });
            if (resp) {
                fire("success", resp.message);
                setTimeout(() => {
                    window.location.reload();
                }, 2000);
            };
            return;
        }
        const resp = await AppModServices.addPrimaryMailing({
            moduleId: mod.id,
            primaryMailingList: [primValue],
            secondryMailingList: [secValue]
        });
        if (resp) {
            fire("success", resp.message);
            setTimeout(() => {
                window.location.reload();
            }, 2000);
        }
       

    }
    const editSec = async (prim) => {
        setSecMail(prim)
    }
    const updateSec = async (mod) => {
        if (secValue.length === 0) {
            const resp = await AppModServices.addSecondaryMail({
                moduleId: mod.id,
                primaryMailingList: [primValue],
                secondryMailingList: [mod.secondaryMailingList]
            });
            if (resp) {
                fire("success", resp.message);
                setTimeout(() => {
                    window.location.reload();
                }, 2000);
            }
            return;
        }
        const resp = await AppModServices.addSecondaryMail({
            moduleId: mod.id,
            primaryMailingList: [primValue],
            secondryMailingList: [secValue]
        });
        if (resp) {
            fire("success", resp.message);
            setTimeout(() => {
                window.location.reload();
            }, 2000);
        }
        

    }

    useEffect(() => {
        listAppMod();
    }, [pageIndex, search])
    return (<>
        <Layout title="Application Modules" pageTag={"application_module"} current={'/modules'}>
            <React.Fragment>
                <main>
                    <div className='max-w-7xl mx-auto px-4 sm:px-6 md:px-8'>
                        <div className="px-4 sm:px-6 lg:px-8">
                            <div className="sm:flex sm:items-center">
                                <div className="sm:flex-auto flex">
                                    <div className="mt-1 relative rounded-md shadow-sm">
                                        <div className="absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none">
                                            <SearchIcon className="h-5 w-5 text-gray-400" aria-hidden="true" />
                                        </div>
                                        <input
                                            type="text"
                                            name="user"
                                            id="user"
                                            onChange={(e) => searchMod(e.target.value)}
                                            className="focus:ring-indigo-500 focus:border-indigo-500 block w-full pl-10 sm:text-sm border-gray-300 rounded-md"
                                            placeholder="Search modules"
                                        />
                                    </div>
                                </div>
                            </div>
                            {appMod.length === 0 ? (
                                <div className="mt-8"> No data available for these dates to show. </div>
                            ) : 
                            <>
                            <div className="mt-8 flex flex-col">
                                <div className="-my-2 -mx-4 overflow-x-auto sm:-mx-6 lg:-mx-8">
                                    <div className="inline-block min-w-full py-2 align-middle md:px-6 lg:px-8">
                                        <div className="relative overflow-hidden ring-1 ring-black ring-opacity-5 md:rounded-lg">
                                            <table className="min-w-full table-fixed divide-y divide-gray-300">
                                                <thead>
                                                    <tr>

                                                        <th scope="col" className="min-w-[9rem] py-3.5 pl-5 pr-3 italic font-normal text-left text-sm text-gray-400">
                                                            Module Name
                                                        </th>

                                                        <th scope="col" className="px-2 py-3.5 text-left text-sm italic font-normal text-gray-400">
                                                            Module Tag
                                                        </th>
                                                        <th scope="col" className="min-w-[12rem] px-3 py-3.5 text-left text-sm italic font-normal text-gray-400">
                                                            Primary Mailing List
                                                        </th>
                                                        <th scope="col" className="px-3 py-3.5 text-left text-sm italic font-normal text-gray-400">
                                                        </th>
                                                        <th scope="col" className="px-3 py-3.5 text-left text-sm italic font-normal text-gray-400">
                                                            Secondary Mailing list
                                                        </th>
                                                        <th scope="col" className="px-3 py-3.5 text-left text-sm italic font-normal text-gray-400">
                                                        </th>

                                                        <th scope="col" className="px-3 py-3.5 text-left text-sm italic font-normal text-gray-400">

                                                        </th>
                                                        <th scope="col" className="px-3 py-3.5 text-left text-sm italic font-normal text-gray-400">
                                                            <span className="sr-only">Edit</span>
                                                        </th>
                                                    </tr>
                                                </thead>
                                                <tbody className="divide-y divide-gray-200 bg-white">
                                                    {appMod.map((person, i) => (
                                                        <tr key={i} className="bg-gray-50">
                                                            <td className="whitespace-nowrap px-3 py-4 text-sm text-gray-900">{person.moduleName}</td>
                                                            <td className="whitespace-nowrap px-3 py-4 text-sm text-gray-900">{person.moduleTag}</td>
                                                            {primMail !== person.id ?
                                                                <> <td className="whitespace-nowrap px-3 py-4 text-sm text-gray-900">{person.primaryMailingList}</td> </> :
                                                                <>
                                                                    <td className="whitespace-nowrap px-3 py-4 text-sm text-gray-900">
                                                                        <textarea
                                                                            type="text"
                                                                            name="rate"
                                                                            rows="4"
                                                                            className='w-96'
                                                                            placeholder={person.primaryMailingList}
                                                                            defaultValue={person.primaryMailingList}
                                                                            onChange={(e) => handlePriMail(e.target.value)}
                                                                        />

                                                                    </td></>
                                                            }
                                                            {primMail !== person.id ?
                                                                <td className="whitespace-nowrap py-4 pl-3 pr-4 text-right text-sm font-medium sm:pr-6">
                                                                    <button onClick={() => edit(person.id)}>
                                                                        <PencilIcon className="w-4" />
                                                                    </button>
                                                                </td> :
                                                                <td className="whitespace-nowrap px-3 py-4 text-sm text-gray-900">
                                                                    <button
                                                                        onClick={() => updatePrim(person)} >
                                                                        <CheckIcon className='w-8' />
                                                                    </button>
                                                                </td>
                                                            }
                                                            {secMail !== person.id ?
                                                                <> <td className="whitespace-nowrap px-3 py-4 text-sm text-gray-900">{person.secondaryMailingList}</td> </> :
                                                                <>
                                                                    <td className="whitespace-nowrap px-3 py-4 text-sm text-gray-900">
                                                                        <textarea
                                                                            type="text"
                                                                            name="rate"
                                                                            rows="4"
                                                                            className='w-96'
                                                                            placeholder={person.secondaryMailingList}
                                                                            defaultValue={person.secondaryMailingList}
                                                                            onChange={(e) => handleSecMail(e.target.value)}
                                                                        />

                                                                    </td></>
                                                            }
                                                            {secMail !== person.id ?
                                                                <td className="whitespace-nowrap py-4 pl-3 pr-4 text-right text-sm font-medium sm:pr-6">
                                                                    <button onClick={() => editSec(person.id)}>
                                                                        <PencilIcon className="w-4" />
                                                                    </button>
                                                                </td> :
                                                                <td className="whitespace-nowrap px-3 py-4 text-sm text-gray-900">
                                                                    <button
                                                                        onClick={() => updateSec(person)} >
                                                                        <CheckIcon className='w-8' />
                                                                    </button>
                                                                </td>
                                                            }
                                                        </tr>
                                                    ))}
                                                </tbody>
                                            </table>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <Paginate
                                    nextPage={nextPage}
                                    pageIndex={pageIndex}
                                    totalCount={pageNumber}
                                    totalPages={totalPage}
                                    prevPage={prevPage}
                                    setPageIndex={setPageIndex}
                                />
                        </>}
                        
                        </div>
                    </div>
                </main>

            </React.Fragment>
        </Layout>

    </>);
}